import React from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import authServices from '../../Services/authServices';
import { toast } from 'react-toastify';

export const ForgetPassword = () => {
    const history = useHistory()

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().email('Invalid email address').required('Required'),
        }),

        onSubmit: (values) => {
            let postData = {...values,email:values.email.toLowerCase()}
            authServices.forgot_password(postData).then(res => {
                if (res.status) {
                    toast.success(res.message)
                    history.push('/login')
                } else {
                    toast.error(res.message)
                }
            }).catch((err) => {
                console.log(err,'err')
            })
        },
    });



    return (
        <div className="authentication-bg">
            <div className="account-pages w-100 pt-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-8 col-lg-6 col-xl-5">
                            <div>
                                <div className="card">
                                    <a href="/" className="mt-4 d-block auth-logo">
                                    <img src="/admin/assets/images/logo_dark.png" alt="" height={70} className="logo logo-dark" />
                                                <img src="/admin/assets/images/logo_dark.png" alt="" height={45} className="logo logo-light" />

                                        {/* <img src="/admin/assets/images/logo_dark.svg" alt="" height={50} className="logo logo-dark" />
                                        <img src="/admin/assets/images/logo-light.png" alt="" height={22} className="logo logo-light" /> */}
                                    </a>
                                    <div className="card-body">
                                        <div className="text-center">
                                            <h5 className="text-primary">Forgot Password</h5>
                                            {/* <p className="text-muted">Reset Password with Minible.</p> */}
                                        </div>
                                        <div className="p-2 mt-4">
                                            <div className="alert alert-success text-center mb-4" role="alert">
                                                Enter your Email and instructions will be sent to you!
                                            </div>
                                            <form onSubmit={(e) => formik.handleSubmit(e)}>
                                                <div className="mb-3">
                                                    <label className="form-label" htmlFor="useremail">Email</label>
                                                    <input id="useremail" 
                                                     className={'form-control' + (formik.touched.email ? !formik.errors.email ? ' is-valid' : ' is-invalid' : '')}
                                                     type="email" {...formik.getFieldProps('email')}
                                                     placeholder="Enter email"
                                                     />
                                                    {formik.touched.email && formik.errors.email ? (
                                                    <div className="text-danger">{formik.errors.email}</div>
                                                ) : null}
                                                </div>
                                                <div className="mt-3 text-end">
                                                    <button type="submit" 
                                                    className="btn btn-primary w-sm waves-effect waves-light" >Submit</button>
                                                </div>
                                                <div className="mt-4 text-center">
                                                    <p className="mb-0">Remember It ? <a onClick={() => history.push('/login')} className="fw-medium text-primary pointer"> Signin </a></p>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                             
                            </div>
                        </div>
                    </div>
                    {/* end row */}
                </div>
                {/* end container */}
            </div>
            {/* JAVASCRIPT */}
        </div>
    )
}
